<template>
  <div class="lookData">
    <new-head isBack zai="false" title="数据查看" class="pos-top"> </new-head>
    <!-- <div class="itemRow">
      <div class="lable">数据导出网页</div>
      <div class="itemMain url">www.baidu.com</div>
      <div class="itemRight">
        <div class="copy" @click="copy">复制</div>
      </div>
    </div> -->
    <div class="itemRow">
      <div class="lable">任务发布时间</div>
      <div class="itemMain">
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio name="1">当期</van-radio>
          <van-radio name="2">年度</van-radio>
        </van-radio-group>
      </div>
      <div class="itemRight" @click="openPicker">请选择</div>
    </div>
    <div class="dataRow">
      <div class="dataItem flex-center">
        <h5>{{ statisticsData.allAwardNum }}元</h5>
        <span>已发放奖金</span>
      </div>
      <div class="dataItem flex-center">
        <h5>{{ statisticsData.allTaskNum }}个</h5>
        <span>任务个数</span>
      </div>
      <div class="dataItem flex-center">
        <h5>{{ statisticsData.tasksMemberNum }}人</h5>
        <span>发布人</span>
      </div>
      <div class="dataItem flex-center">
        <h5>{{ statisticsData.receiverMember }}人</h5>
        <span>领取人</span>
      </div>
    </div>

    <el-table :data="tableData" border style="width: 100%" class="table">
      <el-table-column type="index" width="50" label="序号">
      </el-table-column>
      <el-table-column prop="title" label="任务名称" width="80">
      </el-table-column>
      <el-table-column prop="createby_account" label="发布人工号" width="100">
      </el-table-column>
      <el-table-column prop="createby_name" label="发布人姓名" width="100">
      </el-table-column>
      <el-table-column prop="createby_mobile" label="发布人联系方式" width="120">
      </el-table-column>
      <el-table-column prop="create_time" label="任务发布时间" width="120">
      </el-table-column>
      <el-table-column prop="account" label=" 领取人工号" width="120">
      </el-table-column>
      <el-table-column prop="username" label=" 领取人姓名" width="100">
      </el-table-column>
      <el-table-column prop="mobile" label="领取人联系方式" width="120">
      </el-table-column>
      <el-table-column prop="complete_time" label="任务完成时间" width="120">
      </el-table-column>
      <el-table-column prop="award" label="奖励金额" width="80">
      </el-table-column>

    </el-table>
    <download-excel :data="exclData" worksheet="My Worksheet" :name="month + '数据明细'" class="export flex-center">导出数据
    </download-excel>



    <van-popup v-model="datetimeShow" position="bottom">
      <div class="timePopup">
        <div class="timePopupTitle">
          培训时间选择
          <img src="@/assets/image/close.png" alt="" class="close" @click="datetimeShow = false" />
        </div>
        <div class="datetimePicker" :class="{ typePiker: radio == '2' }">
          <van-datetime-picker v-model="currentDate" type="year-month" title="培训时间选择" :min-date="minDate"
            :max-date="maxDate" :formatter="formatter" :show-toolbar="false" />
        </div>

        <button class="timeComplete" @click="timeComplete">完成</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import { statisticsDataApi } from "@/api/api/user";
export default {
  data() {
    return {
      radio: "1",
      statisticsData: {},

      tableData: [
      ],
      datetimeShow: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 11, 1),
      currentDate: new Date(),
      month: "",
    };
  },
  computed: {
    exclData() {
      let data = this.tableData.map((item, i) => {
        let newItem = {}
        newItem.序号 = i + 1
        newItem.任务名称 = item.title
        newItem.发布人工号 = item.createby_account
        newItem.发布人姓名 = item.createby_name
        newItem.发布人联系方式 = item.createby_mobile
        newItem.任务发布时间 = item.create_time
        newItem.领取人工号 = item.account
        newItem.领取人姓名 = item.username
        newItem.领取人联系方式 = item.mobile
        newItem.任务完成时间 = item.complete_time
        newItem.奖励金额 = item.award
        return newItem
      })
      console.log(data);
      return data
    }
  },
  created() {
    let date = new Date()
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    this.month = y + '-' + (m < 10 ? '0' + m : m)
    this.getData();
  },
  methods: {
    async getData() {
      let res = await statisticsDataApi(this.month);
      let data = res.data.data;
      console.log(data);
      this.statisticsData = data.statisticsData;
      this.tableData = data.taskData.map(item => {
        item.award = this.moneyFormat(item.award)
        item.create_time = this.timestampFormat(item.create_time)
        item.complete_time = this.timestampFormat(item.complete_time)
        return item
      })
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    timeComplete() {
      this.datetimeShow = false;
      var date = this.currentDate;
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      if (this.radio == 1) {
        this.month = y + "-" + (m >= 10 ? m : "0" + m);
      } else if (this.radio == 2) {
        this.month = y;
      }
      console.log(this.month);
      this.getData();
    },
    copy() {
      const str = "925076321";
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.value = str;
      input.setAttribute("readOnly", "readOnly");
      input.select();
      document.execCommand("Copy");
      Toast("已复制");
      document.body.removeChild(input);
    },
    openPicker() {
      this.datetimeShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.van-popup {
  background: none;
}

// 组件没有单独选年的配置, 选择年时, 隐藏月份列的样式
.typePiker {
  /deep/ .van-picker__columns {
    .van-picker-column:nth-child(2) {
      display: none;
    }
  }
}

.lookData {
  font-size: 14px;
  padding-top: 44px;
  padding-bottom: 100px;

  .itemRow {
    height: 50px;
    border-bottom: 1px solid #d8d8d8;
    padding: 0 15px;
    display: flex;
    align-items: center;

    .lable {
      width: 110px;
    }

    .itemMain {
      flex: 1;
    }

    .url {
      -webkit-user-select: auto;
    }

    .itemRight {
      .copy {
        color: #0286ff;
      }
    }
  }

  .dataRow {
    height: 81px;
    border-bottom: 1px solid #d8d8d8;
    display: flex;
    align-items: center;

    .dataItem {
      flex: 1;
      flex-direction: column;
      justify-content: space-between;
      height: 41px;
      border-right: 1px solid #dbdbdb;

      >h5 {
        font-size: 19px;
      }

      >span {
        font-size: 12px;
        color: #a8a8a8;
      }

      &:last-child {
        border-right: none;
      }
    }
  }

  .timePopup {
    width: 100%;
    height: 292px;
    background: #ffffff;
    border-radius: 8px 8px 0px 0px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .timePopupTitle {
      height: 46px;
      line-height: 46px;
      text-align: center;
      font-size: 15px;
      font-weight: 600;
      position: relative;

      .close {
        position: absolute;
        width: 15px;
        height: 15px;
        padding: 5px;
        box-sizing: content-box;
        top: 14px;
        right: 14px;
      }
    }

    .datetimePicker {
      flex: 1;
      overflow: hidden;
    }

    .timeComplete {
      width: 100%;
      height: 47px;
      line-height: 47px;
      background: #0286ff;
      font-size: 15px;
      color: #ffffff;
    }
  }
}

.export {
  float: right;
  width: 100px;
  background-color: #0286ff;
  color: #fff;
  height: 30px;
  border-radius: 5px;
  margin-top: 20px;
  margin-right: 20px;
}
</style>